"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationWidgetRoot = exports.getBadgeContent = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const ContextProviders_1 = require("../../../components/Elements/ContextProviders");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const models_1 = require("../../../models");
const useNotificationCountState_1 = require("../hooks/useNotificationCountState");
const NotificationsPopup_1 = require("./NotificationsPopup");
exports.testIds = {
    bellButton: 'notification_widget-trigger_button',
    badge: 'notification_widget-count_badge',
};
const getBadgeContent = (data) => {
    if (data) {
        let badgeContent = 0;
        if (data.new > 0) {
            badgeContent = data.new;
        }
        else if (data.unread) {
            badgeContent = data.unread;
        }
        return badgeContent;
    }
    return 0;
};
exports.getBadgeContent = getBadgeContent;
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    iconButton: {
        height: 32,
        width: 32,
        marginLeft: theme.spacing(1),
        padding: 0,
    },
    icon: {
        width: 22,
        height: 22,
    },
    badge: ({ isNewNotificationsPresent }) => {
        const size = isNewNotificationsPresent ? 16 : 10;
        return {
            background: theme.palette.status.error,
            height: size,
            width: size,
            ...(isNewNotificationsPresent
                ? { minWidth: size, borderRadius: '6px', right: '10%' }
                : { borderRadius: '50%', right: '24%', top: '9%' }),
        };
    },
}));
const NotificationWidget = ({ app = models_1.WebsocketApp.ship }) => {
    const { countData } = (0, useNotificationCountState_1.useNotificationCountState)(app);
    const isNewNotificationsPresent = !!countData && countData.new > 0;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const classes = useStyles({ isNewNotificationsPresent });
    const theme = (0, silhouette_core_1.useTheme)();
    const handleClickButton = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const onClose = () => {
        setAnchorEl(null);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { color: "inherit", className: classes.iconButton, "data-tracking-id": "notification_widget-trigger_button", "data-testid": exports.testIds.bellButton, onClick: handleClickButton, sx: {
                    '&:hover': {
                        backgroundColor: theme.palette.grey[800],
                    },
                }, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Badge, { badgeContent: (0, exports.getBadgeContent)(countData), max: 9, variant: isNewNotificationsPresent ? 'standard' : 'dot', classes: { badge: classes.badge }, "data-testid": exports.testIds.badge, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.NotificationImportantOutlinedIcon, { className: classes.icon }) }) }), !!anchorEl && (0, jsx_runtime_1.jsx)(NotificationsPopup_1.NotificationsPopup, { open: Boolean(anchorEl), anchorEl: anchorEl, onClose: onClose, app: app })] }));
};
const NotificationWidgetRoot = ({ config, app }) => {
    return ((0, jsx_runtime_1.jsx)(ContextProviders_1.ContextProviders, { children: (0, jsx_runtime_1.jsx)(ConfigContext_1.ConfigContextProvider, { config: config, children: (0, jsx_runtime_1.jsx)(LoggerContext_1.LoggerContextProvider, { children: (0, jsx_runtime_1.jsx)(NotificationWidget, { app: app }) }) }) }));
};
exports.NotificationWidgetRoot = NotificationWidgetRoot;
//# sourceMappingURL=NotificationWidgetRoot.js.map